<script setup>
import { computed } from 'vue';
import { cva } from 'class-variance-authority';

const props = defineProps({
  items: { type: Array, required: true }, // [{ id, title }]
  activeId: { type: String, default: null },
});

const linkClass = computed(() =>
  cva(
    'toc-link block pl-5 pr-3 py-1.5 text-sm font-normal text-[#1c4848]/50 relative',
    {
      variants: {
        active: {
          true: 'active',
          false: '',
        },
      },
    }
  )
);
</script>

<template>
  <nav aria-label="Contents" class="w-full relative">
    <div class="absolute left-0 top-0 bottom-0 w-[1px] bg-[#1c4848]/10"></div>
    <ul class="flex flex-col gap-5 text-sm font-normal text-[#1c4848]/50 relative">
      <li v-for="item in props.items" :key="item.id">
        <a
          :href="`#${item.id}`"
          :class="linkClass({ active: props.activeId === item.id })"
        >
          {{ item.title }}
        </a>
      </li>
    </ul>
  </nav>
</template>

